import React, { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import { EmptyText, ExpandableCard, M, RowKV } from "./managementUi";

// =============================================================
// Các tab dùng chung cho "Chi tiết KPI" (quản lý) và "Chi tiết KPI cá nhân".
// Khớp src/modules/management/statistical-report/detail.tsx của app.
// =============================================================

const fmtDate = (v) => (v ? moment(v).format("DD/MM/YYYY") : "-");

const CardList = ({ data, renderCard, emptyText = "Không dữ liệu" }) => {
  const [expanded, setExpanded] = useState({});
  if (!data || !data.length) return <EmptyText text={emptyText} />;
  return (
    <Flex direction="column" gap="10px" pt="16px" pb="16px">
      {data.map((item, index) =>
        renderCard(item, index, !!expanded[index], () =>
          setExpanded((p) => ({ ...p, [index]: !p[index] }))
        )
      )}
    </Flex>
  );
};

const CardTitle = ({ text }) => (
  <Text fontSize="14px" fontWeight={600} color={M.baseContent} noOfLines={2}>
    {text}
  </Text>
);

export const KpiConsultationTab = ({ data }) => (
  <CardList
    data={data?.consultations}
    renderCard={(item, index, open, toggle) => (
      <ExpandableCard
        key={`${item?.customerCode || "consultation"}-${item?.metricDate || "no-date"}-${index}`}
        open={open}
        onToggle={toggle}
        header={
          <CardTitle
            text={`${item?.customerCode || "-"} ${item?.customerCode ? "-" : ""} ${item?.customerName || "-"}`.trim()}
          />
        }
      >
        <RowKV label="Mã khách hàng (CRM)" value={item?.customerCode || "-"} labelFlex="1" />
        <RowKV label="Tên khách hàng (CRM)" value={item?.customerName || "-"} labelFlex="1" />
        <RowKV label="SĐT khách hàng (CRM)" value={item?.customerPhone || "-"} labelFlex="1" />
        <RowKV label="Ngày tư vấn" value={fmtDate(item?.metricDate)} labelFlex="1" />
      </ExpandableCard>
    )}
  />
);

export const KpiLeadTab = ({ data }) => (
  <CardList
    data={data?.leads}
    renderCard={(item, index, open, toggle) => (
      <ExpandableCard
        key={`${item?.customerCode || "lead"}-${item?.metricDate || "no-date"}-${index}`}
        open={open}
        onToggle={toggle}
        header={
          <CardTitle
            text={`${item?.customerCode || "-"} ${item?.customerCode ? "-" : ""} ${item?.customerName || "-"}`.trim()}
          />
        }
      >
        <RowKV label="Mã khách hàng (CRM)" value={item?.customerCode || "-"} labelFlex="1" />
        <RowKV label="Tên khách hàng (CRM)" value={item?.customerName || "-"} labelFlex="1" />
        <RowKV label="SĐT khách hàng (CRM)" value={item?.customerPhone || "-"} labelFlex="1" />
        <RowKV label="Ngày nhập lead" value={fmtDate(item?.metricDate)} labelFlex="1" />
      </ExpandableCard>
    )}
  />
);

export const KpiTransactionTab = ({ data, onOpenTransaction }) => (
  <CardList
    data={data?.transactions}
    renderCard={(item, index, open, toggle) => (
      <ExpandableCard
        key={`${item?.productCode || "transaction"}-${item?.transactionDate || "no-date"}-${index}`}
        open={open}
        onToggle={toggle}
        onDetailClick={onOpenTransaction ? () => onOpenTransaction(item) : undefined}
        header={
          <CardTitle
            text={`${item?.productCode || "Booking không định danh"} ${item?.productCode ? "-" : ""} ${
              item?.customerName || "-"
            }`.trim()}
          />
        }
      >
        <RowKV label="Mã căn hộ" value={item?.productCode || "-"} labelFlex="1" />
        <RowKV label="Tên khách hàng" value={item?.customerName || "-"} labelFlex="1" />
        <RowKV label="SĐT khách hàng" value={item?.customerPhone || "-"} labelFlex="1" />
        <RowKV label="Ngày giao dịch" value={fmtDate(item?.transactionDate)} labelFlex="1" />
        <RowKV label="" value="Xem chi tiết giao dịch" valueColor={M.primary} labelFlex="1" />
      </ExpandableCard>
    )}
  />
);

export const KpiEvaluationTab = ({ data }) => {
  const comments = data?.evaluation?.leaderComment?.items ?? [];
  return (
    <Box>
      <Box px="0" py="12px" borderBottom="0.5px solid" borderColor={M.border}>
        <Text fontSize="12px" fontWeight={500} color={M.subTitle}>
          {comments.length} đánh giá
        </Text>
      </Box>

      {comments.length === 0 ? (
        <Flex align="center" justify="center" py="50px">
          <Text fontSize="12px" fontWeight={500} color={M.gray}>
            Chưa có đánh giá nào
          </Text>
        </Flex>
      ) : (
        <Flex direction="column" gap="12px" py="16px">
          {comments.map((c, i) => (
            <Box key={`eval-${i}`} border="1px solid" borderColor={M.border} borderRadius="10px" overflow="hidden" bg="white">
              <Flex px="14px" py="12px" justify="space-between" align="flex-start" gap="12px">
                <Text fontSize="12px" fontWeight={500} color={M.subTitle} minW="70px">
                  Lý do
                </Text>
                <Text fontSize="14px" fontWeight={600} color={M.baseContent} flex="1" textAlign="right">
                  {c?.reason || "-"}
                </Text>
              </Flex>
              <Box h="1px" bg={M.border} />
              <Flex px="14px" py="12px" justify="space-between" align="flex-start" gap="12px">
                <Text fontSize="12px" fontWeight={500} color={M.subTitle} minW="70px">
                  Giải pháp
                </Text>
                <Text fontSize="14px" fontWeight={600} color={M.baseContent} flex="1" textAlign="right">
                  {c?.solution || "-"}
                </Text>
              </Flex>
            </Box>
          ))}
        </Flex>
      )}
    </Box>
  );
};
